import { ScanStatus } from '@/constants';

export const getSuccessfulScan = (scansData) => {
  const successfulScan = scansData?.find(
    ({ status }) => status === ScanStatus.Complete
  );

  return successfulScan;
};
